import * as React from "react"

import IfChildren from "../IfChildren"
import StatisticNumber from "./StatisticNumber"

import "./Statistic.style.scss"

type StatisticProps = {
	value?: number
	description?: React.ReactNode
	suffix?: React.ReactNode
	preffix?: React.ReactNode
	valueRender?: (value?: number) => React.ReactNode
	decimals?: number
	spaceBetween?: boolean
}

const Statistic = (props: StatisticProps) => {
	const {
		value,
		description,
		preffix,
		suffix,
		valueRender,
		decimals,
		spaceBetween,
	} = props

	return (
		<div className="statistic">
			<div className="statistic__values">
				<IfChildren as="span" className="statistic__preffix">
					{preffix}
				</IfChildren>
				<IfChildren className="statistic__value">
					{valueRender ? (
						valueRender(value)
					) : (
						<StatisticNumber
							value={value}
							decimals={decimals}
							spaceBetween={spaceBetween}
						/>
					)}
				</IfChildren>
				<IfChildren as="span" className="statistic__suffix">
					{suffix}
				</IfChildren>
			</div>
			<IfChildren className="statistic__description">{description}</IfChildren>
		</div>
	)
}

export default Statistic
